// components
import {
  MInput,
  MIcon,
  MCheckbox,
  MMultiSelect,
  MButton,
  MLink,
  MHelp,
  MModal,
  SkeletonLoader,
  MHint
} from '@marilyn/marilyn-ui';

function registerComponents (Vue) {
  Vue.component('MIcon', MIcon);
  Vue.component('MLink', MLink);
  Vue.component('MHelp', MHelp);
  Vue.component('MHint', MHint);
  Vue.component('MButton', MButton);
  Vue.component('MCheckbox', MCheckbox);
  Vue.component('MInput', MInput);
  Vue.component('MMultiselect', MMultiSelect);
  Vue.component('MModal', MModal);
  Vue.component('SkeletonLoader', SkeletonLoader);
}

export default registerComponents;

